<template>
  <div class="bg-gray-50">
    <div class="max-w-[375px] mx-auto min-h-screen p-4">
      <div class="text-center mb-8 mt-4">
        <h1 class="text-2xl font-bold text-gray-800">山西省第四届</h1>
        <div class="text-xl text-gray-700 mt-2">家庭教育指导技能大赛报名</div>
      </div>

      <div class="grid grid-cols-1 gap-4">
        <a class="block" @click="toPage('signup-list',0)">
          <div class="bg-primary rounded-lg p-6 text-white shadow-lg transition-transform hover:scale-105">
            <div class="flex justify-between items-center">
              <div>
                <h3 class="text-xl font-semibold mb-2">社会成人报名入口</h3>
                <!-- <p class="text-white/80">面向社会各界人士开放报名</p> -->
              </div>
              <i class="fas fa-user-graduate text-3xl"></i>
            </div>
          </div>
        </a>

        <div class="block" @click="toPage('signup-list',1)">
          <div class="bg-secondary rounded-lg p-6 text-white shadow-lg transition-transform hover:scale-105">
            <div class="flex justify-between items-center">
              <div>
                <h3 class="text-xl font-semibold mb-2">高校学生报名入口</h3>
                <!-- <p class="text-white/80">面向在校师生开放报名</p> -->
              </div>
              <i class="fas fa-school text-3xl"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="mt-8 text-center text-sm text-gray-500">
              <p>报名截止时间：2024 年 3 月 31 日</p>
              <p class="mt-2">咨询电话：0351-1234567</p>
          </div> -->
    </div>
  </div>
</template>


<script>
import CountTo from 'vue-count-to'
import { getDashboard } from '@/api/exam/examRecord'
import { courseList } from '@/api/exam/course'
import { wexinShare } from '@/utils/weixinSDK'
import { isWeixin } from "@/utils/utils";

const logoUrl = require("@/assets/img/logo.jpg");
export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      banner_bg: require("@/assets/img/bg-img/bg2.jpg")
    }
  },
  components: {
    CountTo
  },
  created() {

  },
  mounted() {
    document.title = '山西省第四届家庭教育指导技能大赛报名'
  },

  methods: {

    getDashboard() {
      getDashboard().then(resp => {
        this.dashboardInfo = resp.data;
      });
    },
    // 加载课程列表
    getCourseList() {
      courseList(this.courseQuery).then(response => {
        this.courseList = response.rows;
      }).catch(() => {
      })
    },
    handleStartCourse(course) {
      // messageWarn(this, '功能正在开发中！')
      this.$router.push({ name: 'course-details', query: { courseId: course.id } })
    },
    toPage(pageName,type) {
      this.$router.push({ name: pageName, query: { type: type } })
    },

  },

}
</script>
<style lang="scss" scoped>
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.p-4 {
  padding: 1rem;
}

.max-w-\[375px\] {
  max-width: 375px;
}

.min-h-screen {
  min-height: 100vh;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.text-center {
  text-align: center;
}


.mt-4 {
  margin-top: 1rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31, 41, 55, 1);
}

.font-bold {
  font-weight: 700;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55, 65, 81, 0.9);
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.gap-4 {
  gap: 1rem;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid {
  display: grid;
}

.block {
  display: block;
}



.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}


.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.p-6 {
  padding: 1.5rem;
}

.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(255 159 67 / var(--tw-bg-opacity, 1));
}

.rounded-lg {
  border-radius: 12px;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.flex {
  display: flex;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.p-6 {
  padding: 1.5rem;
}

.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(58 191 248 / var(--tw-bg-opacity, 1));
}

.rounded-lg {
  border-radius: 12px;
}
</style>
